import { useAuthQuery } from '#lib/hooks/use-auth-query.js';
import { jsonHeaders } from '#lib/helpers/fetch.js';
import { useState, useEffect } from 'react';

async function fetchLanguages(data, authHeaders) {
    const { query, lang } = data;
    const response = await fetch(`${API_URL}/p/languages?query=${query ?? ''}&lang=${lang ?? 'en'}`, {
        method: 'GET',
        headers: { ...jsonHeaders, ...authHeaders }
    });
    return await response.json();
}

export default function useLanguages(lang) {
    const [query, setQuery] = useState('');

    const { data, refetch, isSuccess, isLoading, ...queryProps } = useAuthQuery({
        queryKey: ['languages', query, lang],
        queryFn: () => fetchLanguages({ query, lang }),
        staleTime: Infinity,
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        retry: false,
        cacheTime: 0
    });

    const queryLanguages = (newQuery) => {
        setQuery(newQuery);
    };

    return {
        languages: data?.languages ?? [],
        refetch,
        isLoading,
        isSuccess,
        queryLanguages,
        ...queryProps
    };
}
